// Module
var code = `<template>
  <require from="./report-date-widget.scss"></require>
  <require from="./date-range-converter"></require>

  <!-- beautify ignore:start -->
  <style>
    .report-date-widget-\${id} {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
      text-align: \${textAlign || 'left'};
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="report-date-widget report-date-widget-\${id}">
    <span if.bind="hideFrom">\${customerService.selectedDates.to | date:'dd.MM.yyyy'}</span>
    <span else>\${customerService.selectedDates.from | date:'dd.MM.yyyy'} - \${customerService.selectedDates.to | date:'dd.MM.yyyy'}</span>
  </div>
</template>
`;
// Exports
export default code;